import { useContext } from 'react'
import { GameContext } from '../GameContextF.jsx'
import { QrGameInvite } from '../common/QrGameInvite.jsx'
import { HostControls } from '../common/HostControlsF.jsx'
import { PlayerStatuses } from './PlayerStatuses.jsx'
import { RecentGames } from '../common/RecentGamesF.jsx'
import { LeaveGameBtn } from '../LeaveGameBtnF.jsx'
import { throPtErr } from '../../../sharedF/throwErrorF/sharedErrF.mts'
import * as gameTasks from './GameTasksF.jsx'
import { useNoSleepNow } from '../../../componentsF/hooksF/useNoSleepF.tsx'
import { objHash } from '../../../sharedF/objHashF.mts'

export const TelDrawStarted = () => {
  useNoSleepNow()

  return <RecentGames>
    <TelDrawInner />
    <PlayerStatuses />
    <HostControls />
    <QrGameInvite />
    <LeaveGameBtn />
  </RecentGames>
}
const TelDrawInner = () => {
  const {myState: {publicState: {myTaskName}, taskPrompt, assignedStackName}} = useContext(GameContext)

  const Comp = gameTasks[myTaskName]
  if (Comp) return <Comp key={objHash([myTaskName, taskPrompt, assignedStackName])} {...{}} />

  throPtErr('noCompForTask', {myTaskName})
}